"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorPriceWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var AnnualMotorPriceWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorPriceWidget, _super);
    function AnnualMotorPriceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.getHasDebtAndIsChangeAddressMTA = function (interaction) {
            return interaction.factors.debtAmount > 0 && interaction.process === services_1.INTERACTION_PROCESS_MTA_CHANGE_ADDRESS;
        };
        _this.getPrice = function (interaction, hasDebtAndIsChangeAddressMTA) {
            var additionalPremium;
            var returnPremium;
            var paymentRequired;
            var refundRequired;
            if (hasDebtAndIsChangeAddressMTA) {
                additionalPremium = (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.mtaAndDebtCombinedAdditionalAmount);
                returnPremium = (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.mtaAndDebtCombinedReturnAmount);
                paymentRequired = interaction.factors.mtaAndDebtCombinedAdditionalAmount > 0;
                refundRequired = interaction.factors.mtaAndDebtCombinedReturnAmount > 0;
            }
            else {
                additionalPremium = (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.additionalPremium);
                returnPremium = (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.returnPremium);
                paymentRequired = interaction.factors.additionalPremium > 0;
                refundRequired = interaction.factors.returnPremium > 0;
            }
            var showSpreadAmountWithInterest = _this.getSetting("showSpreadAmountWithInterest", false);
            if (showSpreadAmountWithInterest &&
                interaction.factors.monthlyPaymentSpreadWithInterestAmount &&
                interaction.factors.monthlyPaymentSpreadWithInterestAmount > 0) {
                return "".concat((0, commonFunctions_1.getAmountToDisplay)(interaction.factors.monthlyPaymentSpreadWithInterestAmount));
            }
            else if (paymentRequired) {
                return additionalPremium;
            }
            else if (refundRequired) {
                return "".concat(returnPremium, " refund");
            }
            else {
                return;
            }
        };
        _this.getAdditionalWording = function (interaction, hasDebtAndIsChangeAddressMTA) {
            var isMonthlyPayment = interaction.factors.premiumType === services_1.PremiumType.monthly;
            if (isMonthlyPayment) {
                return _this.getMonthlyAdditionalWording(interaction, hasDebtAndIsChangeAddressMTA);
            }
            else {
                return _this.getAnnualAdditionalWording(interaction);
            }
        };
        _this.getMonthlyAdditionalWording = function (interaction, hasDebtAndIsChangeAddressMTA) {
            var monthlyAdditionalWording = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            var returnPremium;
            var paymentRequired;
            var refundRequired;
            if (hasDebtAndIsChangeAddressMTA) {
                returnPremium = (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.mtaAndDebtCombinedReturnAmount);
                paymentRequired = interaction.factors.mtaAndDebtCombinedAdditionalAmount > 0;
                refundRequired = interaction.factors.mtaAndDebtCombinedReturnAmount > 0;
            }
            else {
                returnPremium = (0, commonFunctions_1.getAmountToDisplay)(interaction.factors.returnPremium);
                paymentRequired = interaction.factors.additionalPremium > 0;
                refundRequired = interaction.factors.returnPremium > 0;
            }
            var currentMonthlyPrice = _this.getMonthlyInstalmentAmount(_this.state.oldInteraction);
            var newMonthlyPrice = _this.getMonthlyInstalmentAmount(interaction);
            var upfrontPaymentAmount = (0, commonFunctions_1.getUpfrontPaymentAmount)(interaction.factors);
            var remainingSpreadAmount = (0, commonFunctions_1.getRemainingSpreadAmount)(interaction.factors);
            var upfrontPaymentWording = _this.getUpfrontPaymentWording(upfrontPaymentAmount, remainingSpreadAmount);
            var upfrontRefundWording = _this.getUpfrontInterestCorrectionRefundWording(interaction);
            var installmentsHasAmountRemaining = _this.state.installmentsHasAmountRemaining;
            var hideMonthlyAdditionalWording = _this.getSetting("hideMonthlyAdditionalWording", false);
            var isPayFullPrice = interaction.uistate.payFullPrice;
            if (installmentsHasAmountRemaining && !hideMonthlyAdditionalWording) {
                if (paymentRequired && (!isPayFullPrice && !hasDebtAndIsChangeAddressMTA)) {
                    monthlyAdditionalWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [upfrontPaymentAmount ?
                                upfrontPaymentWording :
                                (0, jsx_runtime_1.jsx)("p", { className: "margin-bottom-16 margin-top-32", children: "This amount will be added to the outstanding balance and spread evenly over your remaining monthly payments." }), (currentMonthlyPrice && newMonthlyPrice) && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { className: "m-0", children: ["You currently pay ", (0, jsx_runtime_1.jsx)("strong", { children: currentMonthlyPrice }), " a month."] }), (0, jsx_runtime_1.jsxs)("p", { children: ["The amount of ", (0, jsx_runtime_1.jsx)("strong", { children: remainingSpreadAmount }), " will increase your remaining monthly payments to ", (0, jsx_runtime_1.jsx)("strong", { children: newMonthlyPrice }), " a month."] })] }), upfrontRefundWording] });
                }
                else if (refundRequired) {
                    monthlyAdditionalWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "margin-bottom-16 margin-top-32", children: "This amount will be deducted from the outstanding balance and spread evenly over your remaining monthly payments." }), (currentMonthlyPrice && newMonthlyPrice) && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { className: "m-0", children: ["You currently pay ", (0, jsx_runtime_1.jsx)("strong", { children: currentMonthlyPrice }), " / month."] }), (0, jsx_runtime_1.jsxs)("p", { children: ["The refund of ", (0, jsx_runtime_1.jsx)("strong", { children: returnPremium }), " has reduced your remaining monthly payments to ", (0, jsx_runtime_1.jsx)("strong", { children: newMonthlyPrice }), " / month."] })] }), upfrontRefundWording] });
                }
                else if (!paymentRequired && !refundRequired) {
                    monthlyAdditionalWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold margin-top-32 margin-bottom-0", children: "Great news! There is no extra cost for the changes you\u2019ve made." }), currentMonthlyPrice && (0, jsx_runtime_1.jsxs)("p", { className: "font-weight-bold margin-bottom-32", children: ["You'll continue to pay ", currentMonthlyPrice, " a month."] })] });
                }
            }
            else if (!installmentsHasAmountRemaining) {
                if (refundRequired) {
                    monthlyAdditionalWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "margin-top-32 margin-bottom-32", children: "As you have no outstanding monthly payments left, this amount will be refunded to the bank account/card that your monthly payments were being debited from within the next 3-5 working days." }), upfrontRefundWording] });
                }
                else if (paymentRequired) {
                    monthlyAdditionalWording =
                        (0, jsx_runtime_1.jsx)("p", { className: "margin-bottom-16 margin-top-32", children: "As you have no outstanding monthly payments left, this amount will need to be paid on a card now." });
                }
                else if (!paymentRequired && !refundRequired) {
                    monthlyAdditionalWording = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold margin-top-32 margin-bottom-32 mb-0", children: "Great news! There is no extra cost for the changes you\u2019ve made." }), currentMonthlyPrice && (0, jsx_runtime_1.jsxs)("p", { className: "font-weight-bold margin-bottom-32", children: ["You'll continue to pay ", currentMonthlyPrice, " a month."] })] });
                }
            }
            return monthlyAdditionalWording;
        };
        _this.getAnnualAdditionalWording = function (interaction) {
            var annualAdditionalWording = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            var refundRequired = interaction.factors.returnPremium > 0;
            var paymentRequired = interaction.factors.additionalPremium > 0;
            if (refundRequired || interaction.factors.mtaAndDebtCombinedReturnAmount > 0) {
                annualAdditionalWording = _this.getAnnualAdditionalWordingForRefund(interaction);
            }
            else if (!paymentRequired) {
                annualAdditionalWording = (0, jsx_runtime_1.jsx)("p", { className: "font-weight-bold margin-top-32 margin-bottom-0", children: "Great news! There is no change in price for the changes you've made." });
            }
            return annualAdditionalWording;
        };
        _this.getAnnualAdditionalWordingForRefund = function (interaction) {
            var _a;
            var truncatedCardNumbersForRefund = (_a = interaction.uistate) === null || _a === void 0 ? void 0 : _a.truncatedCardNumbersForRefund;
            if ((truncatedCardNumbersForRefund === null || truncatedCardNumbersForRefund === void 0 ? void 0 : truncatedCardNumbersForRefund.length) === 1) {
                return (0, jsx_runtime_1.jsxs)("p", { className: "margin-top-32 margin-bottom-32", children: ["Your refund will be issued to the card ending", ' ', services_1.CommonHelpers.renderBracketedList(truncatedCardNumbersForRefund), " within 3-5 working days."] });
            }
            else if ((truncatedCardNumbersForRefund === null || truncatedCardNumbersForRefund === void 0 ? void 0 : truncatedCardNumbersForRefund.length) > 1) {
                return (0, jsx_runtime_1.jsxs)("p", { className: "margin-top-32 margin-bottom-32", children: ["As you used more than one card to pay for your policy (and any changes made), your refund will be", ' ', "split across the cards ending ", services_1.CommonHelpers.renderBracketedList(truncatedCardNumbersForRefund), ".", ' ', "You should receive this within 3-5 working days."] });
            }
            var paymentCard = (0, commonFunctions_1.findMainAnnualPaymentCard)(_this.state.party, _this.state.mainCardId);
            if (paymentCard) {
                var cardNumberTruncated = paymentCard.cardNumberObfuscated.split('******')[1];
                return (0, jsx_runtime_1.jsxs)("p", { className: "margin-top-32 margin-bottom-32", children: ["Your refund will be issued to the card ending", ' ', cardNumberTruncated, " within 3-5 working days."] });
            }
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        };
        _this.getUpfrontPaymentWording = function (upfrontPaymentAmount, remainingPaymentAmount) {
            var installmentsHasAmountRemaining = _this.props.interaction.uistate.installmentsHasAmountRemaining;
            if (upfrontPaymentAmount && installmentsHasAmountRemaining) {
                return (0, jsx_runtime_1.jsxs)("p", { className: "margin-top-32", children: ["You\u2019ll need to pay ", (0, jsx_runtime_1.jsx)("strong", { children: upfrontPaymentAmount }), " upfront now. The remaining balance of ", (0, jsx_runtime_1.jsx)("strong", { children: remainingPaymentAmount }), " will be added to your monthly payments."] });
            }
            else {
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            }
        };
        _this.state = {
            mainCardIdLoaded: false,
            partyLoaded: false,
            oldInteractionLoaded: false,
            installmentsHasAmountRemaining: false,
            installmentsHasAmountRemainingLoaded: false
        };
        return _this;
    }
    AnnualMotorPriceWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getProfile().subscribe(function (output) {
            _this.setState({
                party: output,
                partyLoaded: true
            });
        });
        this.customerPortalService.getPolicyPropertyByPropertyKey(this.props.interaction.agreementNumber, services_1.MAIN_ANNUAL_PAYMENT_CARD).subscribe(function (property) {
            _this.setState({
                mainCardId: property.value,
                mainCardIdLoaded: true
            });
        });
        this.customerPortalService.getPolicy(this.props.engine.getInteraction().agreementNumber).subscribe(function (policy) {
            _this.setState({
                oldInteraction: policy.interaction,
                oldInteractionLoaded: true
            });
        });
        this.customerPortalService.getCombinedInstalmentsInfoByPolicyNumber(this.props.engine.getInteraction().agreementNumber).toPromise()
            .then(function (instalmentsInfo) {
            var remainingAmountPresent = Math.abs(instalmentsInfo === null || instalmentsInfo === void 0 ? void 0 : instalmentsInfo.remainingAmount) === 0;
            _this.setState({
                installmentsHasAmountRemaining: !remainingAmountPresent,
                installmentsHasAmountRemainingLoaded: true
            });
        });
    };
    AnnualMotorPriceWidget.prototype.render = function () {
        var interaction = this.props.engine.getInteraction();
        if (this.state.partyLoaded && this.state.mainCardIdLoaded && this.state.oldInteractionLoaded && this.state.installmentsHasAmountRemainingLoaded &&
            interaction.factors) {
            var hasDebtAndIsChangeAddressMTA = this.getHasDebtAndIsChangeAddressMTA(interaction);
            var additionalWording = this.getAdditionalWording(interaction, hasDebtAndIsChangeAddressMTA);
            var price = this.getPrice(interaction, hasDebtAndIsChangeAddressMTA);
            return ((0, jsx_runtime_1.jsxs)("div", { className: "panel policy-change-price", children: [price &&
                        (0, jsx_runtime_1.jsx)("p", { className: "price font-weight-bold margin-bottom-16", children: price }), price && (0, jsx_runtime_1.jsx)("p", { className: "m-0", children: "All figures include Insurance Premium Tax" }), !hasDebtAndIsChangeAddressMTA && additionalWording] }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    AnnualMotorPriceWidget.prototype.getMonthlyInstalmentAmount = function (interaction) {
        return interaction.paymentDetails.instalmentPlan.monthlyPayment &&
            (0, commonFunctions_1.getAmountToDisplay)(interaction.paymentDetails.instalmentPlan.monthlyPayment);
    };
    AnnualMotorPriceWidget.prototype.getUpfrontInterestCorrectionRefundWording = function (interaction) {
        var upfrontInterestCorrectionRefund = Math.abs(interaction.paymentDetails.instalmentPlan.upfrontInterestCorrectionRefund);
        var upfrontInterestCorrectionRefundCondition = upfrontInterestCorrectionRefund !== null && upfrontInterestCorrectionRefund > 1;
        if (upfrontInterestCorrectionRefundCondition) {
            return (0, jsx_runtime_1.jsxs)("p", { className: "text-center", children: ["You'll also receive an upfront refund of ", (0, jsx_runtime_1.jsx)("strong", { children: (0, commonFunctions_1.getAmountToDisplay)(upfrontInterestCorrectionRefund) }), ' ', "due to the interest you paid."] });
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualMotorPriceWidget.prototype, "customerPortalService", void 0);
    return AnnualMotorPriceWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualMotorPriceWidget = AnnualMotorPriceWidget;
//# sourceMappingURL=AnnualMotorPriceWidget.js.map